function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: e , size: r = 24  } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = s(), t = e !== null && e !== void 0 ? e : a ? c.colors.inverse : c.colors.neutralHigh;
    return /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ o("path", {
            fill: t,
            d: "M21.622 17.874c.202.16.275.426.185.667a.588.588 0 01-.566.4h-5.227c-.033.55-.184 1.362-.759 1.995-.535.602-1.31.907-2.3.907-.988 0-1.764-.305-2.3-.907-.573-.636-.72-1.448-.753-1.995H4.678a.591.591 0 01-.566-.4.584.584 0 01.188-.667c.412-.339.754-.779 1.034-1.302-2.034-.67-3.174-2.35-3.174-5.149 0-3.328 1.62-5.073 4.443-5.412 1.507-3.958 5.924-3.868 6.353-3.843.364-.025 3.002-.098 4.918 1.68 1.28 1.183 1.928 2.889 1.928 5.082v3.804c-.006.073-.185 3.507 1.82 5.14zm-15.577-.137h13.83c-1.449-2.093-1.295-4.896-1.286-5.042V8.93c0-1.84-.519-3.25-1.538-4.199-1.505-1.398-3.688-1.37-4.008-1.367h-.04a.048.048 0 01-.033.002l-.009-.002-.016.002c-.01.002-.02.004-.031-.002-.146-.008-3.538-.193-4.953 2.591 3.311.087 5.235 1.84 5.235 5.468 0 3.74-2.039 5.485-5.52 5.485-.398 0-.77-.031-1.124-.073a6.198 6.198 0 01-.507.902zm8.303 2.398c.322-.356.42-.838.45-1.19h-3.68c.025.352.12.837.445 1.198.308.33.762.499 1.393.499.63-.003 1.084-.171 1.392-.507zM7.678 15.7c2.936 0 4.306-1.358 4.306-4.277.002-2.919-1.367-4.277-4.306-4.277-2.935 0-4.305 1.358-4.305 4.277S4.743 15.7 7.678 15.7zM7.25 12l1.697 1.686.014.014c.125.125.42.423.717.415.334-.008.625-.168.625-.55 0-.332-.496-.733-.496-.733l-1.52-1.51V9.29a.606.606 0 00-.609-.603.604.604 0 00-.608.603v2.285c0 .16.065.314.18.426z"
        })
    }));
}, v = n;
export { v as default };
